import { Check, Droplets } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToId } from "../config/business";

const CHECKLIST = [
  "Suspension",
  "Fluids",
  "Exhaust",
  "Steering",
  "Brakes",
  "Tires",
  "Belts & Hoses",
  "Lights",
  "Battery / Charging System Visual Check",
  "Other Visible Safety & Maintenance Items",
];

export const PromoInspection = () => (
  <section id="promo" className="border-y border-white/5 bg-[#111214] py-20 lg:py-28">
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 lg:grid-cols-2 lg:gap-16 lg:px-8">
      <Reveal className="relative">
        <div className="image-frame relative z-10 overflow-hidden">
          <img
            src="/images/engine.jpg"
            alt="Engine service during an oil change at Auto Trust Centre, Mississauga"
            loading="lazy"
            className="aspect-[4/3] w-full object-cover"
          />
        </div>
        <div className="absolute -bottom-4 -right-4 h-full w-full border-2 border-[#00AEEF]/40" aria-hidden="true" />
      </Reveal>

      <div>
        <Reveal>
          <p className="font-display flex items-center gap-2 text-xs font-bold uppercase tracking-[0.3em] text-[#00AEEF] sm:text-sm">
            <Droplets className="h-4 w-4" />
            Included With Every Oil Change
          </p>
          <h2 className="font-display mt-3 text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-[#f4f4f2] sm:text-4xl lg:text-5xl">
            Oil Changes Include a{" "}
            <span className="text-[#00AEEF]">Free 30-Point Visual Inspection</span>
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <ul
            className="mt-8 grid gap-x-8 gap-y-3.5 sm:grid-cols-2"
            data-testid="promo-checklist"
          >
            {CHECKLIST.map((item) => (
              <li key={item} className="flex items-start gap-2.5 text-sm text-[#e6e7ea]">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#00AEEF]/15">
                  <Check className="h-3.5 w-3.5 text-[#00AEEF]" strokeWidth={3} />
                </span>
                {item}
              </li>
            ))}
          </ul>
          <p className="mt-7 max-w-lg text-xs leading-relaxed text-[#a6a9b1]">
            This is a visual inspection performed alongside your oil change
            service. It is not a government safety inspection, a certified
            inspection, or an Ontario Safety Standards Certificate.
          </p>
          <button
            data-testid="promo-book-oil-change"
            onClick={() => scrollToId("appointment")}
            className="btn-primary mt-8"
          >
            Book an Oil Change
          </button>
        </Reveal>
      </div>
    </div>
  </section>
);
